<template>
  <section class="hero">
    <div class="date">
      <span>0</span><span>4</span>.<span>0</span><span>3</span>.
      <br />
      <span>2</span><span>0</span><span>1</span><span>9</span>.
    </div>

    <div class="scroll-down">
      <svg class="scroll-down-group-1" width="239px" height="30px" viewBox="0 0 239 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g transform="translate(-1562.000000, -953.000000)" stroke-width="2">
                <g transform="translate(1563.000000, 954.000000)">
                    <g transform="translate(0.000000, 0.357422)">
                        <circle stroke="#FFFFFF" cx="34.5" cy="34.5" r="34.5"></circle>
                        <polygon stroke="#FCFCFC" points="15 36.700885 21.1557522 30.5451327 30.0566372 39.4460177 30.0566372 14 38.7079646 14 38.7079646 39.4460177 47.6088496 30.5451327 53.7646018 36.700885 34.3823009 56"></polygon>
                    </g>
                    <g transform="translate(84.000000, 0.357422)">
                        <circle stroke="#FFFFFF" cx="34.5" cy="34.5" r="34.5"></circle>
                        <polygon stroke="#FCFCFC" points="15 36.700885 21.1557522 30.5451327 30.0566372 39.4460177 30.0566372 14 38.7079646 14 38.7079646 39.4460177 47.6088496 30.5451327 53.7646018 36.700885 34.3823009 56"></polygon>
                    </g>
                    <g transform="translate(168.000000, 0.000000)">
                        <circle stroke="#FFFFFF" cx="34.5" cy="34.5" r="34.5"></circle>
                        <polygon stroke="#FCFCFC" points="15 36.700885 21.1557522 30.5451327 30.0566372 39.4460177 30.0566372 14 38.7079646 14 38.7079646 39.4460177 47.6088496 30.5451327 53.7646018 36.700885 34.3823009 56"></polygon>
                    </g>
                </g>
            </g>
        </g>
      </svg>
      <svg class="scroll-down-group-2" width="239px" height="30px" viewBox="0 0 239 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g transform="translate(-1562.000000, -953.000000)" stroke-width="2">
                <g transform="translate(1563.000000, 954.000000)">
                    <g transform="translate(0.000000, 0.357422)">
                        <circle stroke="#FFFFFF" cx="34.5" cy="34.5" r="34.5"></circle>
                        <polygon stroke="#FCFCFC" points="15 36.700885 21.1557522 30.5451327 30.0566372 39.4460177 30.0566372 14 38.7079646 14 38.7079646 39.4460177 47.6088496 30.5451327 53.7646018 36.700885 34.3823009 56"></polygon>
                    </g>
                    <g transform="translate(84.000000, 0.357422)">
                        <circle stroke="#FFFFFF" cx="34.5" cy="34.5" r="34.5"></circle>
                        <polygon stroke="#FCFCFC" points="15 36.700885 21.1557522 30.5451327 30.0566372 39.4460177 30.0566372 14 38.7079646 14 38.7079646 39.4460177 47.6088496 30.5451327 53.7646018 36.700885 34.3823009 56"></polygon>
                    </g>
                    <g transform="translate(168.000000, 0.000000)">
                        <circle stroke="#FFFFFF" cx="34.5" cy="34.5" r="34.5"></circle>
                        <polygon stroke="#FCFCFC" points="15 36.700885 21.1557522 30.5451327 30.0566372 39.4460177 30.0566372 14 38.7079646 14 38.7079646 39.4460177 47.6088496 30.5451327 53.7646018 36.700885 34.3823009 56"></polygon>
                    </g>
                </g>
            </g>
        </g>
      </svg>
      <svg class="scroll-down-group-3" width="239px" height="30px" viewBox="0 0 239 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g transform="translate(-1562.000000, -953.000000)" stroke-width="2">
                <g transform="translate(1563.000000, 954.000000)">
                    <g transform="translate(0.000000, 0.357422)">
                        <circle stroke="#FFFFFF" cx="34.5" cy="34.5" r="34.5"></circle>
                        <polygon stroke="#FCFCFC" points="15 36.700885 21.1557522 30.5451327 30.0566372 39.4460177 30.0566372 14 38.7079646 14 38.7079646 39.4460177 47.6088496 30.5451327 53.7646018 36.700885 34.3823009 56"></polygon>
                    </g>
                    <g transform="translate(84.000000, 0.357422)">
                        <circle stroke="#FFFFFF" cx="34.5" cy="34.5" r="34.5"></circle>
                        <polygon stroke="#FCFCFC" points="15 36.700885 21.1557522 30.5451327 30.0566372 39.4460177 30.0566372 14 38.7079646 14 38.7079646 39.4460177 47.6088496 30.5451327 53.7646018 36.700885 34.3823009 56"></polygon>
                    </g>
                    <g transform="translate(168.000000, 0.000000)">
                        <circle stroke="#FFFFFF" cx="34.5" cy="34.5" r="34.5"></circle>
                        <polygon stroke="#FCFCFC" points="15 36.700885 21.1557522 30.5451327 30.0566372 39.4460177 30.0566372 14 38.7079646 14 38.7079646 39.4460177 47.6088496 30.5451327 53.7646018 36.700885 34.3823009 56"></polygon>
                    </g>
                </g>
            </g>
        </g>
      </svg>
      <svg class="scroll-down-group-4" width="239px" height="72px" viewBox="0 0 239 72" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g transform="translate(-1562.000000, -953.000000)" stroke-width="2">
                <g transform="translate(1563.000000, 954.000000)">
                    <g transform="translate(0.000000, 0.357422)">
                        <circle stroke="#FFFFFF" cx="34.5" cy="34.5" r="34.5"></circle>
                        <polygon stroke="#FCFCFC" points="15 36.700885 21.1557522 30.5451327 30.0566372 39.4460177 30.0566372 14 38.7079646 14 38.7079646 39.4460177 47.6088496 30.5451327 53.7646018 36.700885 34.3823009 56"></polygon>
                    </g>
                    <g transform="translate(84.000000, 0.357422)">
                        <circle stroke="#FFFFFF" cx="34.5" cy="34.5" r="34.5"></circle>
                        <polygon stroke="#FCFCFC" points="15 36.700885 21.1557522 30.5451327 30.0566372 39.4460177 30.0566372 14 38.7079646 14 38.7079646 39.4460177 47.6088496 30.5451327 53.7646018 36.700885 34.3823009 56"></polygon>
                    </g>
                    <g transform="translate(168.000000, 0.000000)">
                        <circle stroke="#FFFFFF" cx="34.5" cy="34.5" r="34.5"></circle>
                        <polygon stroke="#FCFCFC" points="15 36.700885 21.1557522 30.5451327 30.0566372 39.4460177 30.0566372 14 38.7079646 14 38.7079646 39.4460177 47.6088496 30.5451327 53.7646018 36.700885 34.3823009 56"></polygon>
                    </g>
                </g>
            </g>
        </g>
      </svg>
    </div>
  </section>
</template>

<script>
import animations from '@/assets/animations';

export default {
  name: 'HeroSection',

  data() {
    return {};
  },

  mounted() {
    animations.get('loader-date')(this.$el).play();
    animations.get('scroll-down')(this.$el).play();
  },
};
</script>

<style lang="scss" scoped>
.hero {
  position: relative;
  width: 100vw;
  height: calc(var(--vh, 1vh) * 100);

  .date {
    font-size: rem(360px);
    font-size: calc(360px * var(--rw));
    line-height: rem(320px);
    line-height: calc(320px * var(--rw));
    padding: 50px;
    left: 100px;

    @include mq($until: ipadL) {
      font-size: rem(280px);
      line-height: rem(240px);
    }

    @include mq($until: ipadP) {
      font-size: rem(140px);
      line-height: rem(120px);
      padding: 20px;
    }
  }

  .scroll-down {
    position: absolute;
    bottom: 50px;
    right: 100px;

    display: flex;
    flex-direction: column;
  }
}
</style>
